import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAllRoles = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ALL_ROLES.GET_ALL_ROLES
  );
};

export default getAllRoles;